export { ProductDetails } from './ProductDetails';
export { ProductDetailsSkeleton } from './ProductDetails.skeleton';
